module.exports = __webpack_public_path__ + "img/insert-bg-icon.1f0ecfbd.svg";